import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  FileInitInput,
  FileInitResponse,
  fileInitResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIPostFileInit = (
  options?: UseMutationOptions<FileInitResponse, ErrorResponse, FileInitInput>
) =>
  useMutation({
    mutationFn: (data: FileInitInput) =>
      post(API_ENDPOINTS.FILE_INIT, data, fileInitResponseSchema),
    ...options,
  })
